import { Component, Injectable, Input, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { Observable } from 'rxjs/Rx';

import * as globals from '../globals';
import { CommonService } from '../navbar/searchCommon.service';

// Name Service
export interface fileURLData {
  fileURL: string;
}


@Injectable()
export class SharedService {

  public sharingData: fileURLData = { fileURL: '' };
  private fileAttached: {};
  private fileAttachmentsArray: Array<File> = [];
  public customerSearchBool: boolean;
  public customerData: any = [];

  public projectSearchResultBool: boolean;
  public quoteSearchResultBool: boolean;

  materialArray: any = [];
  customerArray: any = [];
  ownerArray: any = [];

  private tenantdataUrl = globals.APIURL + '/tenantdata';
  private projectsUrl = globals.APIURL + '/projects';
  constructor(private http: Http, public authHttp: AuthHttp, private commonService: CommonService) { }

  // This will be used once we get the API working
  syncCorporateInfo() {
    // if the data isn't there, call the API
    this.getCorporateInfo().subscribe(
      data => {
        console.log('syncCorporateInfo: ', JSON.parse(data));
        let jdata = JSON.parse(data);
        this.customerArray = jdata.customers;
        this.ownerArray = jdata.owners;
        this.materialArray = jdata.materials;
      },
      error => {
        console.log('syncCorporateInfo error: ', error);
      });


  }

  getCorporateInfo(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.tenantdataUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Remove this once API completed
  syncCorporateInfoLocal(customerArray, materialArray, ownerArray) {

    this.customerArray = customerArray;
    this.ownerArray = ownerArray;
    this.materialArray = materialArray;
  }

  getCustomerList() {
    return this.customerArray;
  }

  getMaterialList() {
    return this.materialArray;
  }

  getOwnerList() {
    return this.ownerArray;
  }

  saveData(str) {
    console.log('save data function called Received:' + str + ' PREstored : ' + this.sharingData.fileURL);
    this.sharingData.fileURL = str;
    console.log('stored : ' + this.sharingData.fileURL);
  }

  getData() {
    console.log('get data function called, Returning : ', this.sharingData.fileURL);
    return this.sharingData.fileURL;
  }

  setFileAttached(fileDataVar) {
    this.fileAttached = fileDataVar;
  }

  getFileAttached() {
    return this.fileAttached;
  }

  addFileinAttchmentArray(fileAdd: File) {
    this.fileAttachmentsArray.push(fileAdd);
  }

  removeFilefromAttachmentArray(fileAdd: File) {
    for (let i = this.fileAttachmentsArray.length - 1; i >= 0; i--) {
      if (this.fileAttachmentsArray[i] === fileAdd) {
        this.fileAttachmentsArray.splice(i, 1);
      }
    }
  }

  removeAllFilesFromAttachmentArray() {
    let filecount = this.fileAttachmentsArray.length;
    for (let i = 0; i > filecount; i++) {
      this.fileAttachmentsArray.pop();
    }
    this.fileAttachmentsArray = [];
  }

  getFileArrayofAttchments() {
    return this.fileAttachmentsArray;
  }

  setProjectSearchResultBool(searchResult) {
    this.projectSearchResultBool = searchResult;
  }

  getProjectSearchResultBool() {
    return this.projectSearchResultBool;
  }

  setQuoteSearchResultBool(searchResult) {
    this.quoteSearchResultBool = searchResult;
  }

  getQuoteSearchResultBool() {
    return this.quoteSearchResultBool;
  }

  setSearchResultData(page, data, simple = false) {
    if (simple) {
      this.commonService.notifyOther({ option: 'setNewPageSimpleSearchData', value: {page: page, data: data} });
    } else {
      this.commonService.notifyOther({ option: 'setNewPageAdvancedSearchData', value: {page: page, data: data} });
    }
  }

  setCustomerSearchBool(custSearchBool) {
    this.customerSearchBool = custSearchBool;
  }
  getCustomerSearchBool() {
    return this.customerSearchBool;
  }

  setCustomerSearchData(custID, custName) {
    this.customerData.name = custName;
    this.customerData.id = custID;
  }

  getCustomerSearchData() {
    return this.customerData;
  }

  getProjectDetailsById(id: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.projectsUrl + '/' + id, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
    }

    private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shared/shared.service.ts